import { html, slotted } from "@microsoft/fast-element";
/**
 * @public
 */
export function accordionMenuTemplate() {
    return html `
    <template class="accordion-menu">
      <slot
        ${slotted({
        property: "slottedElements"
    })}
      ></slot>
    </template>
  `;
}
export const template = accordionMenuTemplate();
//# sourceMappingURL=accordion-menu.template.js.map